export const passwordRequirements = {
  minLength: {
    label: 'Min 6 characters long',
    fulfilled: false,
  },
  lowercase: {
    label: '1 Uppercase letter',
    fulfilled: false,
  },
  uppercase: { label: '1 Lowercase letter', fulfilled: false },
  digit: { label: '1 Digit', fulfilled: false },
};
